<template>
  <div id="detail">
    <!-- <div class="back" @click="$router.go(-1)">{{ $t("miclive.ui.back") }}</div> -->
    <div class="profile">
      <div
        class="image"
        :style="{ backgroundImage: 'url(' + item.image + ')' }"
      ></div>
      <div class="content">
        <div class="title">{{ item.name }}</div>
        <div class="address">
          {{ item.address }} <br />
          {{ item.city }} <br />
          {{ item.cp }}, {{ item.state }}
        </div>
      </div>
      <template v-if="item.longitud">
        <a
          target="_blank"
          :href="
            'https://maps.google.com/?q=' + item.longitud + ',' + item.latitud
          "
          class="maps"
          >{{ $t("miclive.facilities.go") }}</a
        >
      </template>
    </div>
    <div class="weather" id="weather-meteo-widget" v-html="item.meteocat"></div>
    <template v-if="matches">
      <template v-for="(list, date) in matches">
        <div
          class="title"
          :class="{ collapsed: collapse[date] }"
          @click="collapseMatches(date)"
        >
          {{ date }}
        </div>
        <div v-if="!collapse[date]" class="matches">
          <Match v-for="match in list" :key="match.id" :item="match"></Match>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="loader"></div>
    </template>
  </div>
</template>

<script>
import Match from "@/components/domain/competition/match";
import { Api } from "@/core/api.js";
const api = new Api();

// console.log(data);

export default {
  name: "Facilities_detail",
  components: {
    Match
  },
  props: {
    item: Object
  },
  data() {
    return {
      matches: false,
      collapse: {}
    };
  },
  computed: {},
  methods: {
    load() {
      var self = this;
      var params = {
        facility_id: this.item.id
      };
      this.matches = false;
      api.post("miclive/matches", params).then(function(data) {
        self.matches = self.formatMatches(data.data);
      });
    },
    formatDate(date) {
      return moment(date).format("dddd DD/MM");
    },
    collapseMatches(date) {
      this.collapse[date] = !this.collapse[date];
    },
    formatMatches(matches) {
      var result = {};
      var collapse = {};
      for (var i in matches) {
        var match = matches[i];
        var key = moment(match.date, "YYYY-MM-DD HH:mm").format("dddd DD/MM");
        if (!result[key]) result[key] = [];
        result[key].push(match);

        collapse[key] = moment(key, "dddd DD/MM").isBefore(moment(), "day");
      }

      for (var i in result) {
        result[i].sort(function(a, b) {
          var playing_a = a.status >= 3 && a.status <= 8 ? 1 : 0;
          var playing_b = b.status >= 3 && b.status <= 8 ? 1 : 0;

          var finish_a = a.status >= 8 ? 1 : 0;
          var finish_b = b.status >= 8 ? 1 : 0;

          return (
            playing_b - playing_a ||
            finish_a - finish_b ||
            moment(a.date).unix() - moment(b.date).unix()
          );
        });
      }

      this.collapse = collapse;

      return result;
    }
  },
  created() {
    this.load();
  }
};
</script>

<style lang="scss" scoped>
#detail {
  text-align: left;

  .profile {
    background-color: #fff;
    text-align: left;
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
    .title {
      &:after {
        display: none;
      }
    }

    .image {
      width: 120px;
      height: 80px;
      background-size: cover;
      border-radius: 4px;
    }
    .content {
      padding: 0 10px;
      width: calc(100% - 120px);
      .title {
        color: $main-color;
        font-family: $font-title;
        font-size: 18px;
        margin: 0;
      }
      .address {
        font-size: 14px;
        margin-top: 5px;
      }
    }
    .maps {
      width: 100%;
      background-size: 25px;
      background-position: center left 0px;
      background-image: url("~@/../public/img/marker.svg");
      background-repeat: no-repeat;
      padding: 5px 0;
      padding-left: 30px;
      margin-top: 15px;
      color: $main-color;
      text-transform: uppercase;
      font-size: 14px;
      text-decoration: none;
    }
  }

  .weather {
    padding: 15px 0;
  }

  .title {
    margin: 25px 0 20px 0;
    position: relative;
    cursor: pointer;

    &:after {
      content: " ";
      width: 25px;
      height: 25px;
      background-color: #ccc;
      display: inline-block;
      position: absolute;
      right: 0;
      border-radius: 4px;
      cursor: pointer;
      background: url("~@/../public/img/down.svg") no-repeat center center #ddd;
      background-size: 15px;
      transform: rotate(180deg);
    }

    &.collapsed {
      &:after {
        transform: rotate(0deg);
      }
    }
  }

  .matches {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: minmax(0, 1fr);

    .date {
      font-family: $font-title;
      color: $main-color;
      text-transform: uppercase;
      margin-bottom: 10px;
    }
    .list {
    }
  }
}

.tablet {
  .matches {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
.laptop {
  .matches {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
.desktop {
  .matches {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
</style>

<style lang="scss">
#weather-meteo-widget {
  iframe {
    width: 100%;
    .WidgetMunicipal8d {
      box-shadow: none !important;
    }
  }
}
</style>
